import { Box, Skeleton } from '@mui/material';
import React from 'react';

type MermaidNodeComponentProps = {
  nodes?: number;
};

const MermaidNodeComponent = ({ nodes = 7 }: MermaidNodeComponentProps) => {
  const isDecisionNode = (index: number) => [1, 4].includes(index);

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      gap={3}
      padding={2}
    >
      {[...Array(nodes)].map((_, idx) => (
        <Skeleton
          key={idx}
          variant='rectangular'
          animation='wave'
          sx={{
            width: isDecisionNode(idx) ? '5%' : '70%',
            height: isDecisionNode(idx) ? '20%' : '8%',
            transform: isDecisionNode(idx) ? 'rotate(45deg)' : 'none',
            borderRadius: 2,
            minWidth: isDecisionNode(idx) ? 80 : 180,
            minHeight: isDecisionNode(idx) ? 80 : 60,
          }}
        />
      ))}
    </Box>
  );
};

export default MermaidNodeComponent;
